// extracted by mini-css-extract-plugin
export default {"container":"Market_container__cF9RA"};